import React from "react";
import FormGroupTextInput from "../formGroupTextInput";
import FormGroupSelectInput from "../formGroupSelectInput";
import EditIcon from "../icons/editIcon";
import ActionLink from "../General/actionLink";
import {
    INFO_TEXT_EDIT_WITH_APPROVAL, INFO_TEXT_EDIT_WITHOUT_APPROVAL
} from "../../helpers/variables";

import {
    checkIfQuestionHasPendingChanges,
    checkIfQuestionsHasBeenModified,
} from "../../helpers/questions/functions";

import { checkIfQuestionAnswerUpdateRequiresARAGApproval } from "../../helpers/approvalSettings/functions";

const deleteDisabled = (contactInfo) => {
    return (
        (userMeRoles &&
            userMeRoles.userRoles &&
            userMeRoles.userRoles.length > 0 &&
            !userMeRoles.userRoles.includes('CanDeleteOrganisationContactInfo')) ||
        (numberOfContactInfoRecords(contactInfo.Type) > 1 &&
            contactInfo.IsDefault) || organisationDetails.data.DynamicsId != null
    )
}

const OpponentQuestion = (props) => {
    const {
        opponent,
        opponentQuestions,
        openHistoryModal,
        application,
        isPlain,
        question,
        checkIfQuestionIsEditable,
        updateExtraOpponents,
        opponentIndex,
        mapEditingQuestionOrFieldToEditingSetting,
        openEditQuestionAnswerModal,
        approvalOptions,
        displayRemoveButton,
        onClickActionLink
    } = props;

    const onClickRemoveOpponent = () => {
        onClickActionLink(isPlain, opponentIndex, opponent, question);
    }

    const onClickEditAnswer = () => {
        openEditQuestionAnswerModal({
            questionAnswerForEdit: question,
            questionAnswer: opponent.name,
            questionAnswerOpponent: opponent
        })
    }

    return <div key={opponentIndex}>
        {
            displayRemoveButton &&
            <React.Fragment key={(opponentIndex)}>
                <hr className="generalTab-hr" />
                <ActionLink
                    key={question.name}
                    onClick={onClickRemoveOpponent}
                    label={"Remove"}
                />
            </React.Fragment>
        }
        {
            opponentQuestions.map((oppQuestion) => { // for every sub-question   
                if (oppQuestion.inputType === 'text') {
                    return <FormGroupTextInput
                        onLabelClick={() => openHistoryModal(oppQuestion, opponent.id)}
                        labelAsALink={checkIfQuestionsHasBeenModified(
                            opponent.id,
                            application,
                            "OpponentName",
                            oppQuestion.machineName
                        )}
                        RightWrapper={'col-sm-3'}
                        rightData={
                            [
                                isPlain
                                && checkIfQuestionIsEditable(
                                    question,
                                    null,
                                    "ApplicationOpponent"
                                )
                                && (
                                    <EditIcon
                                        key={1}
                                        informationText={
                                            checkIfQuestionAnswerUpdateRequiresARAGApproval(
                                                mapEditingQuestionOrFieldToEditingSetting(question),
                                                approvalOptions
                                            ) ? INFO_TEXT_EDIT_WITH_APPROVAL : INFO_TEXT_EDIT_WITHOUT_APPROVAL
                                        }
                                        className={
                                            checkIfQuestionAnswerUpdateRequiresARAGApproval(
                                                mapEditingQuestionOrFieldToEditingSetting(question),
                                                approvalOptions
                                            ) ? "edit-icon--orange" : null
                                        }
                                        onClick={onClickEditAnswer}
                                    />
                                ),
                                checkIfQuestionHasPendingChanges(opponent.id, application, "OpponentName") && (
                                    <div
                                        className={"newApplication__awaiting-approval-wrapper pull-right"}
                                        key={2}>
                                        Awaiting Approval
                                    </div>
                                ),
                            ]
                        }
                        isPlain={isPlain}
                        key={oppQuestion.id}
                        autoComplete={'off'}
                        InputWrapper={`col-sm-6 ${isPlain ? "manageSolicitorAccount-data" : "formGroup-textInput-input-wrapper"}`}
                        Label={oppQuestion.name}
                        Required={oppQuestion.isRequired}
                        Name={'name'}
                        Type="text"
                        Value={opponent.name}
                        HandleInputChange={(name, value) => updateExtraOpponents(name, value, opponentIndex)} />
                }
                else if (oppQuestion.inputType === 'drop down') {
                    let name;
                    if (oppQuestion.machineName === 'ProspectsAgainstOpponent') {
                        name = 'prospectsOptionId';
                    } else if (oppQuestion.machineName === 'IsOpponentInsured') {
                        name = 'insuredOptionId'
                    }
                    let options = [{ key: '', value: '' }];
                    if (oppQuestion.hasOwnProperty('options')) {
                        options = [...options, ...oppQuestion.options.map(option => {
                            return {
                                key: option.id,
                                value: option.name
                            }
                        })];
                        const selectedOption = options.find(o =>
                            o.key
                            && opponent[name]
                            && o.key.toString() === opponent[name].toString()
                        );
                        return <div key={oppQuestion.id}>
                            <FormGroupSelectInput
                                onLabelClick={() => openHistoryModal(oppQuestion, opponent.id)}
                                labelAsALink={checkIfQuestionsHasBeenModified(
                                    opponent.id,
                                    application,
                                    "OpponentName",
                                    oppQuestion.machineName
                                )}
                                plainValue={selectedOption ? selectedOption.value : ""}
                                isPlain={isPlain}
                                Label={oppQuestion.name}
                                LeftWrapper="col-sm-3"
                                Required={oppQuestion.isRequired}
                                Name={name}
                                Value={opponent[name]}
                                Options={options} //set options
                                HandleInputChange={(evt) => updateExtraOpponents(evt.target.name, evt.target.value, opponentIndex)}
                                CenterWrapper={`col-sm-6  ${isPlain ? "manageSolicitorAccount-data" : "formGroupSelectInput-select-wrapper"}`}
                                RightWrapper=""
                                SelectStyle={'form-control formGroupSelectInput-select'}

                            />
                            {
                                oppQuestion.options.map(childQuestionOption => {
                                    if (childQuestionOption.id.toString() === opponent[name] && (childQuestionOption.childQuestions.length > 0)) {
                                        return <div key={childQuestionOption.id}>
                                            {
                                                childQuestionOption.childQuestions.map(grandChildQuestion => {
                                                    let options = [{ key: '' }];
                                                    if (grandChildQuestion.hasOwnProperty('options')) {
                                                        options = [...options, ...grandChildQuestion.options.map(option => {
                                                            return {
                                                                key: option.id,
                                                                value: option.name
                                                            }
                                                        })];
                                                    }
                                                    if (grandChildQuestion.machineName === 'ProspectsAgainstOpponent') {
                                                        name = 'prospectsOptionId';
                                                    } else if (grandChildQuestion.machineName === 'OpponentNotInsuredSatisfiedHasFunds' || grandChildQuestion.machineName === 'OpponentDoNotKnowInsuredSatisfiedHasFunds') {
                                                        name = 'satisfiedOptionId'
                                                    }
                                                    else if (grandChildQuestion.machineName === 'WhoIsTheInsurer') {
                                                        name = 'insurerOptionId'
                                                    }
                                                    const selectedOption = options.find(o =>
                                                        o.key
                                                        && opponent[name]
                                                        && o.key.toString() === opponent[name].toString()
                                                    );
                                                    return <div key={childQuestionOption.id}>
                                                        <FormGroupSelectInput
                                                            onLabelClick={() => openHistoryModal(grandChildQuestion, opponent.id)}
                                                            labelAsALink={checkIfQuestionsHasBeenModified(
                                                                opponent.id,
                                                                application,
                                                                "OpponentName",
                                                                grandChildQuestion.machineName
                                                            )}
                                                            plainValue={selectedOption ? selectedOption.value : ""}
                                                            isPlain={isPlain}
                                                            Label={grandChildQuestion.name}
                                                            LeftWrapper="col-sm-3"
                                                            Required={grandChildQuestion.isRequired}
                                                            Name={name}
                                                            Value={opponent[name]}
                                                            key={grandChildQuestion.id}
                                                            Options={options} //set options
                                                            HandleInputChange={(evt) => updateExtraOpponents(evt.target.name, evt.target.value, opponentIndex)}
                                                            CenterWrapper={`col-sm-6 ${isPlain ? "manageSolicitorAccount-data" : "formGroupSelectInput-select-wrapper"}`}
                                                            RightWrapper=""
                                                            SelectStyle={'form-control formGroupSelectInput-select'}
                                                        />
                                                        {
                                                            grandChildQuestion.options.map(grandchildChildQuestionOption => {
                                                                if (grandchildChildQuestionOption.id.toString() === opponent[name] && (grandchildChildQuestionOption.childQuestions.length > 0)) {
                                                                    return <div key={grandchildChildQuestionOption.id}>
                                                                        {
                                                                            grandchildChildQuestionOption.childQuestions.map(grandchildChildQuestion => {
                                                                                if (grandchildChildQuestion.machineName === 'NameOfInsurerOther') {
                                                                                    name = 'otherInsurerName';
                                                                                }
                                                                                let otherInsurerAnswer =application && application.applicationAnswersDtos ? application.applicationAnswersDtos.find(({ id }) => id === opponent.otherInsurerId) : ''

                                                                                return <div key={grandchildChildQuestion.id}>
                                                                                    <FormGroupTextInput
                                                                                        onLabelClick={() => openHistoryModal(grandchildChildQuestion, opponent.id)}
                                                                                        labelAsALink={checkIfQuestionsHasBeenModified(
                                                                                            opponent.id,
                                                                                            application,
                                                                                            "OpponentName",
                                                                                            grandchildChildQuestion.machineName
                                                                                        )}
                                                                                        isPlain={isPlain}
                                                                                        autoComplete={'off'}
                                                                                        Label={grandchildChildQuestion.name}
                                                                                        RightWrapper="col-sm-3"
                                                                                        Required={grandchildChildQuestion.isRequired}
                                                                                        Name={name}
                                                                                        Type="text"
                                                                                        Value={otherInsurerAnswer.text}
                                                                                        key={grandchildChildQuestion.id}
                                                                                        InputWrapper={`col-sm-6 ${isPlain ? "manageSolicitorAccount-data" : "formGroup-textInput-input-wrapper"}`}
                                                                                        HandleInputChange={(name, value) => updateExtraOpponents(name, value, opponentIndex)}
                                                                                    />
                                                                                </div>
                                                                            })}
                                                                    </div>
                                                                }
                                                            })
                                                        }</div>
                                                }

                                                )}
                                        </div>

                                    }
                                })}
                        </div>
                    }
                }
            })}
    </div>
};

export default OpponentQuestion
    ;